/**
 * api.js
 * 
 * All api requests - may need to separate into relevant folder
 */ 


import client from "./client";
import clientGraph from "./clientGraph";
import forms from "./forms";
import users from "./users";
import map from "./map"
import groups from "./groups"
import reports from "./reports";
import asa from "./asa";
import wellbeing from "./wellbeing";
import goals from "./goals";
import sroi from "./sroi";
import metrics from "./metrics";
import tkPeople from "./tkPeople";
import documents from "./documents";
import lookupOptions from "./lookupOptions";
import documentScraping from "./documentScraping";
import referralEngagements from "./referralEngagements";
import publicKoTatou from "./publicKoTatou";
import groupEngagements from "./groupEngagements";
import enquiries from "./enquiries";

export default {
	users,
	forms,
	client,
	clientGraph,
	map,
	groups,
	asa,
	reports,
	wellbeing,
	goals,
	sroi,
	metrics,
	tkPeople,
	documents,
	lookupOptions,
	documentScraping,
	referralEngagements,
	publicKoTatou,
	groupEngagements,
	enquiries
};
